import styled from 'styled-components';
export const OtpContainer = styled.div `
    display: flex;

    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
    }
`;
//# sourceMappingURL=OtpContainer.Styled.js.map